export default {
  OPEN_EMPLOYEE_ENGAGEMENT_REPORT: 'employee-engagement:open',
  RUN_ADVANCED_REPORT: 'advanced-report:run',
};
